// Mock data for StabbedBySteve.com

export const piercingPhotos = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/zsxo61b9_anchorclavical-1.jpg",
    title: "Clavicle Surface Piercing",
    category: "surface"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/welt5jr6_IMG00121.jpg",
    title: "Nape Piercing",
    category: "surface"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/g5ikn4h5_IMG00132-1.jpg",
    title: "Ear Piercings",
    category: "ear"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/ucoeicpt_IMG00148.jpg",
    title: "Nape Surface Piercing",
    category: "surface"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/w1bhoi20_IMG00382-1.jpg",
    title: "Navel Piercing",
    category: "body"
  }
];

export const pricingData = {
  oral: [
    { name: "Tongue", price: 40 },
    { name: "Tongue web", price: 50 },
    { name: "Snake eyes", price: 60 },
    { name: "Cheek", price: 40, special: "2 for $70" },
    { name: "Lip", price: 40 },
    { name: "Monroe", price: 40 },
    { name: "Medusa", price: 40 },
    { name: "Snake bites", price: 70 },
    { name: "Spider bites", price: 70 },
    { name: "Smiley", price: 50 },
    { name: "Angel kiss", price: 50 },
    { name: "Ashley", price: 50 }
  ],
  facial: [
    { name: "Nose", price: 30 },
    { name: "Septum", price: 40 },
    { name: "Eyebrow", price: 40 },
    { name: "Horizontal eyebrow", price: 50 },
    { name: "Anti eyebrow", price: 50 },
    { name: "Bridge", price: 50 }
  ],
  ear: [
    { name: "Ear lobe (single)", price: 20 },
    { name: "Ear lobe (both sides)", price: 30 },
    { name: "Ear lobe 1-10y", price: "$30 and up" },
    { name: "Horizontal ear lobe", price: 40, special: "both sides for $70" },
    { name: "Cartilage", price: 30, special: "2 for $70" },
    { name: "Conch", price: 30 },
    { name: "Daith", price: 40 },
    { name: "Rook", price: 40 },
    { name: "Tragus", price: 45, special: "2 for $70" },
    { name: "Anti tragus", price: 40 },
    { name: "Industrial", price: 50 },
    { name: "Any Orbital", price: 45 },
    { name: "Pinna (forward helix)", price: 45, special: "2 for $80 / 3 for $105" },
    { name: "Snug", price: 40 },
    { name: "Stacked ear lobe", price: "$55 for one side / $95 for both sides" }
  ],
  body: [
    { name: "Navel", price: 40 },
    { name: "Lower Navel", price: 40 },
    { name: "Nipple", price: 40, special: "2 for $70" },
    { name: "Custom fit Surface bar", price: 50 },
    { name: "Custom fit Surface flex bar (PTFE)", price: 65 },
    { name: "Dermal Anchor", price: 60, special: "2 for $100" },
    { name: "Stretching", price: 10, special: "for 2 piercings" },
    { name: "Genital piercings", price: "Ask for pricing" }
  ]
};

export const aftercareInstructions = [
  {
    title: "Cleaning",
    instructions: [
      "Wash your hands thoroughly before touching your piercing",
      "Clean 2-3 times daily with saline solution or piercing aftercare spray",
      "Gently remove any crusties with a clean cotton swab soaked in saline",
      "Pat dry with clean paper towel or let air dry"
    ]
  },
  {
    title: "What to Avoid",
    instructions: [
      "Do NOT use alcohol, hydrogen peroxide, or harsh soaps",
      "Avoid swimming pools, hot tubs, and bodies of water for 2-4 weeks",
      "Don't touch or twist your jewelry unnecessarily",
      "Avoid sleeping directly on the piercing",
      "No oral contact for oral piercings during healing"
    ]
  },
  {
    title: "Healing Times",
    instructions: [
      "Ear lobes: 6-8 weeks",
      "Cartilage: 3-6 months",
      "Nostril: 2-4 months",
      "Navel: 6-9 months",
      "Tongue: 4-6 weeks",
      "Nipple: 6-12 months",
      "Surface piercings: 3-6 months"
    ]
  },
  {
    title: "Warning Signs",
    instructions: [
      "Excessive redness, swelling, or heat around the piercing",
      "Yellow or green discharge (clear or white is normal)",
      "Severe pain that worsens over time",
      "Fever or chills",
      "If you experience any of these, contact me immediately or seek medical attention"
    ]
  }
];

// Mock user authentication
export const mockUsers = [
  {
    id: 1,
    email: "client@example.com",
    password: "password123",
    name: "John Doe",
    isPierced: true
  }
];

// Mock chat messages
export const mockChatMessages = [
  {
    id: 1,
    userId: 1,
    message: "Hi! I have a question about my new piercing.",
    sender: "user",
    timestamp: new Date(Date.now() - 3600000)
  },
  {
    id: 2,
    userId: 1,
    message: "Hey! Sure, what's going on with it?",
    sender: "admin",
    timestamp: new Date(Date.now() - 3500000)
  }
];